import { Component } from '@angular/core';
import { IHeaderAngularComp } from '@ag-grid-community/angular';
import { IHeaderParams } from '@ag-grid-community/core/dist/esm/es6/headerRendering/cells/column/headerComp';

@Component({
    selector: 'app-reset-filters-header',
    templateUrl: './reset-filters-header.component.html',
    styleUrls: ['./reset-filters-header.component.scss'],
    standalone: false,
})
export class ResetFiltersHeaderComponent implements IHeaderAngularComp {
    public params!: IHeaderParams;
    public headerName: string | undefined;

    agInit(params: any): void {
        this.params = params;
        this.headerName = params.headerName;
    }

    refresh(params: IHeaderParams): boolean {
        return false;
    }

    clearFilters() {
        this.params.api.setFilterModel(null);
    }
}
